module.exports = __webpack_public_path__ + "static/img/tU_b@2x.7631c79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/businessTicketDiscount/tU_b@2x.png
// module id = i9mN
// module chunks = 69